import Server from "src/server";
import Util from "src/util/util";


export default {
    namespaced: true,
    state: {
        isLoading: true,
        workspace: null,
        workspaces: [],
    },
    mutations: {

    },
    actions: {

        reset(context) {
            context.state.workspace = null;
            context.state.workspaces = [];
        },

        setWorkspace(context, { workspace }) {
            context.state.workspace = workspace;
            var user = context.rootState.userStore.user;
            user.parms.workspace = workspace._id;
            context.dispatch("userStore/updateUserParms", { user: user }, { root: true });
            context.dispatch("wfStore/setWorkflows", null, { root: true });
            context.dispatch("connStore/setConnections", null, { root: true });
            context.dispatch("logStore/setLogs", null, { root: true });
        },

        async setWorkspaces(context) {
            try {
                let user = context.rootState.userStore.user;
                context.state.isLoading = true;
                let result = await Server.post("getWorkspaces", { user }).promise;
                context.state.isLoading = false;
                if (!result.data.success)
                    throw (result.data.error);

                context.state.workspaces = result.data.workspaces;
                return result;
            }
            catch (e) {
                console.log("Failed 'getWorkspaces' server call. " + e.toString());
                context.state.isLoading = false;
                return { data: { success: false, error: e } };
            }
        },

        async insertWorkspace(context, { workspace }) {
            try {
                let result = await Server.post("insertWorkspace", { workspace }).promise;
                if (!result.data.success)
                    throw (result.data.error);

                context.state.workspaces.push(result.data.workspace);
                return result;
            }
            catch (e) {
                console.log("Failed 'createWorkspace' server call. " + e.toString());
                return { data: { success: false, error: e } };
            }
        },

        async updateWorkspace(context, { workspace }) {
            try {
                let result = await Server.post("updateWorkspace", { workspace }).promise;
                if (!result.data.success)
                    throw (result.data.error);

                context.state.workspaces = Util.replaceInArray(context.state.workspaces, "_id", result.data.workspace);
                return result;
            }
            catch (e) {
                console.log("Failed 'updateWorkspace' server call. " + e.toString());
                return { data: { success: false, error: e } };
            }
        },

        async deleteWorkspace(context, { workspace }) {
            try {
                let result = await Server.post("deleteWorkspace", { workspace }).promise;
                if (!result.data.success)
                    throw (result.data.error);

                context.state.workspaces = Util.removeFromArrayByKey(context.state.workspaces, "_id", workspace._id);
                return result;
            }
            catch (e) {
                console.log("Failed 'deleteWorkspace' server call. " + e.toString());
                context.isLoading = false;
                return { data: { success: false, error: e } };
            }
        },

    },
    getters: {
        userWorkspaces: (state, getters, rootState) => {
            let currentUser = rootState.userStore.user;
            let userWorkspaces = state.workspaces.filter(workspace => {
                // check users
                let hasUser = workspace.users.find(user => {
                    return user._id == currentUser._id;
                });
                if (hasUser)
                    return true;

                // check groups
                let hasGroup = workspace.groups.find(group => {
                    let hasUser = group.users.find(user => {
                        return user._id == currentUser._id;
                    });
                    if (hasUser)
                        return true;
                    return false;
                });
                if (hasGroup)
                    return true;

                return false;
            });
            return userWorkspaces;
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/workspace.js